import axios from "@/api/axiosInstance";
import { UpdateTeamRequest, UpdateTeamResponse } from "./types";

export const updateTeam = async (
  uuid: string,
  requestData: UpdateTeamRequest,
): Promise<UpdateTeamResponse> => {
  const response = await axios.put<UpdateTeamResponse>(
    `/api/private/employee-directory/teams/${uuid}`,
    requestData,
  );
  return response.data;
};
